import { doc, getDoc } from "firebase/firestore";

// Deduplicate only requests that are currently in flight. Results are not
// retained, so permission changes and revocations are never served from an
// application-level cache.
const inFlightReads = new Map();

function getOnce(key, loader) {
  const existing = inFlightReads.get(key);
  if (existing) return existing;

  const request = loader().finally(() => {
    if (inFlightReads.get(key) === request) {
      inFlightReads.delete(key);
    }
  });
  inFlightReads.set(key, request);
  return request;
}

export function getUserDocument(db, uid) {
  return getOnce(`user:${uid}`, () => getDoc(doc(db, "users", uid)));
}

export function getPropertyDocument(db, propertyId) {
  return getOnce(`property:${propertyId}`, () =>
    getDoc(doc(db, "properties", propertyId))
  );
}

export function getPropertyAccessDocument(db, propertyId, uid) {
  return getOnce(`access:${propertyId}:${uid}`, () =>
    getDoc(doc(db, "properties", propertyId, "access", uid))
  );
}
